function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  filter: "url(#blob-3-negative_svg__filter0_d)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  clipPath: "url(#blob-3-negative_svg__clip0)"
}, React.createElement("path", {
  opacity: 0.2,
  d: "M203.477 64.741c24.757-1.49 51.07 7.042 68.64 24.546 16.64 16.578 16.291 42.676 21.764 65.518 4.424 18.457 8.12 36.362 7.193 55.319-1.01 20.662-1.509 42.109-12.805 59.44-12.07 18.52-30.052 34.67-51.638 39.437-21.173 4.675-42.189-5.74-62.102-14.32-17.911-7.718-31.829-20.55-47.067-32.722-18.909-15.102-47.042-23.877-53.123-47.3-6.055-23.323 11.744-45.778 23.498-66.812 10.926-19.554 24.508-36.757 42.113-50.606 19.081-15.011 39.294-31.041 63.527-32.5z",
  fill: "#7C94A1"
}), React.createElement("path", {
  d: "M139.979 73.015c20.694-13.669 47.748-19.437 71.716-13.063 22.7 6.037 35.447 28.814 51.608 45.858 13.059 13.773 25.213 27.431 33.889 44.311 9.456 18.399 19.747 37.223 18.63 57.879-1.193 22.074-8.691 45.052-25.002 59.973-15.998 14.635-39.406 16.124-60.941 18.649-19.371 2.272-37.84-1.882-57.123-4.804-23.926-3.624-52.677 2.843-69.655-14.402-16.905-17.171-12.719-45.516-13.057-69.609-.314-22.398 2.847-44.087 11.168-64.883 9.02-22.54 18.509-46.53 38.767-59.91z",
  fill: "#fff"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, React.createElement("clipPath", {
  id: "blob-3-negative_svg__clip0"
}, React.createElement("path", {
  fill: "#fff",
  d: "M0 0h375v375H0z"
})), React.createElement("filter", {
  id: "blob-3-negative_svg__filter0_d",
  x: -5,
  y: 16,
  width: 384.334,
  height: 390.734,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), React.createElement("feOffset", {
  dy: 24
}), React.createElement("feGaussianBlur", {
  stdDeviation: 16
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.901961 0 0 0 0 0.156863 0 0 0 0 0.239216 0 0 0 0.1 0"
}), React.createElement("feBlend", {
  mode: "multiply",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

function SvgBlob3Negative(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 375 375",
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgBlob3Negative;